import {useLocation, useNavigate} from "react-router-dom";
import { useEffect, useState } from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import 'react-quill/dist/quill.snow.css';
import { getBusinessStory } from "../../actions/BusinessPages";
import './style/BusinessStory.css'
import { IMAGE_URL } from "../../path";
import { updateBusinessStory } from "../../actions/BusinessPages";

function BusinessStory() {
    const ReactQuill = require('react-quill');
    const modules = {
        toolbar: [
          [{ 'header': [1, 2, 3, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'align': [] }],
          ['link', 'image'],
          ['clean'],
          // You can also add custom handlers or components here
        ],
      };


    const location = useLocation();
    const user = location.state?.user;

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const [section1Right, setSection1Right] = useState('');
    const [section2Left, setSection2Left] = useState('');
    const [section2Right, setSection2Right] = useState('');

    const [imageFileDesktop1, setImageFileDesktop1] = useState<File | null>(null);
    const [previewUrlDesktop1, setPreviewUrlDesktop1] = useState<string>('');

    const [imageFileMobile1, setImageFileMobile1] = useState<File | null>(null);
    const [previewUrlMobile1, setPreviewUrlMobile1] = useState<string>('');

    const [imageFileDesktop2, setImageFileDesktop2] = useState<File | null>(null);
    const [previewUrlDesktop2, setPreviewUrlDesktop2] = useState<string>('');

    const [imageFileMobile2, setImageFileMobile2] = useState<File | null>(null);
    const [previewUrlMobile2, setPreviewUrlMobile2] = useState<string>('');

    const [businessStory, setBusinessStory] = useState<any[]>([]);

    useEffect(() => {
        getBusinessStory()
          .then(response => {
            const data = response.data;
            setBusinessStory(data);

            setSection1Right(data[0]?.right_text || '');
            setSection2Left(data[2]?.left_text || '');
            setSection2Right(data[2]?.right_text || '');

            // Set preview image URLs
            setPreviewUrlDesktop1(IMAGE_URL  + data[1]?.image);
            setPreviewUrlMobile1(IMAGE_URL  + data[1]?.mobile_image);
            setPreviewUrlDesktop2(IMAGE_URL  + data[3]?.image);
            setPreviewUrlMobile2(IMAGE_URL  + data[3]?.mobile_image);
          })
          .catch(error => {
            // console.error("Failed to fetch business story:", error);
          });
      }, []);

    const [isCollapsed, setIsCollapsed] = useState(true);



const saveBusinessStory = async () => {
  try {
    const formData = new FormData();

    // Append text content
    formData.append("section1", section1Right);
    formData.append("section2L", section2Left);
    formData.append("section2R", section2Right);

    // Append images if selected
    if (imageFileDesktop1) formData.append("image1", imageFileDesktop1);
    if (imageFileMobile1) formData.append("mobile_image1", imageFileMobile1);
    if (imageFileDesktop2) formData.append("image2", imageFileDesktop2);
    if (imageFileMobile2) formData.append("mobile_image2", imageFileMobile2);

    // Use the imported API method
    const response = await updateBusinessStory(formData);

    if (response.status === 201) {
      alert("Business story saved successfully!");
    } else {
      console.error("Save failed:", response.data);
      alert("Failed to save. Please try again.");
    }
  } catch (error) {
    console.error("Error saving business story:", error);
    alert("An error occurred while saving.");
  }
};

    const [image1Error, setImage1Error] = useState<string>("");
    const [image2Error, setImage2Error] = useState<string>("");

    const removeSelectedImage = (type: "desktop" | "mobile", id: 1 | 2) => {
        if (type === "desktop") {
            if (id == 1) {

                setImageFileDesktop1(null);
                setPreviewUrlDesktop1(`${IMAGE_URL}${businessStory[1].image}`);
            }
            else {
                setImageFileDesktop2(null);
                setPreviewUrlDesktop2(`${IMAGE_URL}${businessStory[3].image}`);
            }

        } else {
            if (id == 1) {
                setImageFileMobile1(null);
                setPreviewUrlMobile1(`${IMAGE_URL}${businessStory[1].mobile_image}`);
            } else {
                setImageFileMobile2(null);
                setPreviewUrlMobile2(`${IMAGE_URL}${businessStory[3].mobile_image}`);
            }

        }
      };

      const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>, type: "desktop" | "mobile", id: 1 | 2) => {
        const file = e.target.files?.[0];
        if (id == 1) {
            if (file) {
                if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
                  setImage1Error("Please upload a valid image file (jpg, jpeg, or png).");
                  if (type === "desktop") setImageFileDesktop1(null);
                  else setImageFileMobile1(null);
                  return;
                }

                setImage1Error("");
                const objectUrl = URL.createObjectURL(file);

                if (type === "desktop") {
                  setImageFileDesktop1(file);
                  setPreviewUrlDesktop1(objectUrl);
                } else {
                  setImageFileMobile1(file);
                  setPreviewUrlMobile1(objectUrl);
                }
              }
        } else {
            if (file) {
                if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
                  setImage2Error("Please upload a valid image file (jpg, jpeg, or png).");
                  if (type === "desktop") setImageFileDesktop2(null);
                  else setImageFileMobile2(null);
                  return;
                }

                setImage2Error("");
                const objectUrl = URL.createObjectURL(file);

                if (type === "desktop") {
                  setImageFileDesktop2(file);
                  setPreviewUrlDesktop2(objectUrl);
                } else {
                  setImageFileMobile2(file);
                  setPreviewUrlMobile2(objectUrl);
                }
              }
        }

      };



    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className="main-admin-page-inner">
                <label><strong>{businessStory[0]?.title}</strong></label>
                <ReactQuill
          id="section1Right"
          value={section1Right}
          onChange={setSection1Right}
          modules={modules}
          style={{ minHeight: '200px', marginBottom: '50px', height: '200px' }}
        />
        <br />
        <div className="images-flex">
            <div>
                {/* Desktop Image Upload */}
            <div className="content-form-field">
              <label><strong>Desktop Image</strong></label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, "desktop", 1)}
                style={{ margin: '10px 0' }}
              />
              {image1Error && <div style={{ color: 'red' }}>{image1Error}</div>}
              {previewUrlDesktop1 && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={previewUrlDesktop1}
                    alt="Desktop Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                  />
                  <br />
                  <button type="button" onClick={() => removeSelectedImage("desktop", 1)} style={{ marginTop: '5px' }}>
                    Remove Desktop Image
                  </button>
                </div>
              )}
            </div>


            </div>
            <div>
                {/* Mobile Image Upload */}
            <div className="content-form-field">
              <label><strong>Mobile Image</strong></label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, "mobile", 1)}
                style={{ margin: '10px 0' }}
              />
              {image1Error && <div style={{ color: 'red' }}>{image1Error}</div>}
              {previewUrlMobile1 && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={previewUrlMobile1}
                    alt="Mobile Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                  />
                  <br />
                  <button type="button" onClick={() => removeSelectedImage("mobile", 1)} style={{ marginTop: '5px' }}>
                    Remove Mobile Image
                  </button>
                </div>
              )}
            </div>
            </div>

        </div>
<br />

<label><strong>{businessStory[2]?.title}</strong></label>
        <div className="section-flex">

            <div>
                <ReactQuill
                    id="section2Left"
                    value={section2Left}
                    onChange={setSection2Left}
                    modules={modules}
                    style={{ minHeight: '200px', marginBottom: '50px', height: '200px' }} />
            </div>
            <div className="section-flex-2">
                <ReactQuill
                    id="section2Right"
                    value={section2Right}
                    onChange={setSection2Right}
                    modules={modules}
                    style={{ minHeight: '200px', marginBottom: '50px', height: '200px' }} />
            </div>
        </div>

        <div className="images-flex-2">
            <div>
                {/* Desktop Image Upload */}
            <div className="content-form-field">
              <label><strong>Desktop Image</strong></label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, "desktop", 2)}
                style={{ margin: '10px 0' }}
              />
              {image2Error && <div style={{ color: 'red' }}>{image2Error}</div>}
              {previewUrlDesktop1 && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={previewUrlDesktop2}
                    alt="Desktop Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                  />
                  <br />
                  <button type="button" onClick={() => removeSelectedImage("desktop", 2)} style={{ marginTop: '5px' }}>
                    Remove Desktop Image
                  </button>
                </div>
              )}
            </div>


            </div>
            <div>
                {/* Mobile Image Upload */}
            <div className="content-form-field">
              <label><strong>Mobile Image</strong></label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, "mobile", 2)}
                style={{ margin: '10px 0' }}
              />
              {image2Error && <div style={{ color: 'red' }}>{image2Error}</div>}
              {previewUrlMobile2 && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={previewUrlMobile2}
                    alt="Mobile Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                  />
                  <br />
                  <button type="button" onClick={() => removeSelectedImage("mobile", 2)} style={{ marginTop: '5px' }}>
                    Remove Mobile Image
                  </button>
                </div>
              )}
            </div>
            </div>

        </div>

        <div style={{ marginTop: '30px' }}>
  <button onClick={saveBusinessStory} style={{ padding: '10px 20px', fontSize: '16px' }}>
    Save Changes
  </button>
</div>

                </div>
            </div>
        </div>
    );
}

export default BusinessStory;
